import { appConstants } from '../../../shared/constants/appConstants';

export const trustyService = {
    /**
     * Loads and filters items for the game.
     * Stub: currently ignores lessonId and collects all vocabulary items from all data keys.
     */
    fetchGameData: (lessonId) => {
        try {
            const dataPrefix = appConstants.localStorageDataPrefix;
            const vocabType = appConstants.scenarioItemTypeVocabulary;
            const allItems = [];

            // Iterate through all localStorage keys
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);

                // If it's a data file (rwd_data_...)
                if (key.startsWith(dataPrefix)) {
                    const rawData = localStorage.getItem(key);
                    if (!rawData) continue;

                    try {
                        const fileContent = JSON.parse(rawData);
                        if (!Array.isArray(fileContent)) continue;

                        // Extract vocabulary items
                        fileContent.forEach(item => {
                            if (item?.scenarioItems) {
                                item.scenarioItems
                                    .filter(si => si.type === vocabType && si.translations)
                                    .forEach(si => {
                                        allItems.push({
                                            ...si.translations,
                                            id: si.id || Math.random().toString(36).substr(2, 9),
                                            sourceFile: key // Optional: track which file it came from
                                        });
                                    });
                            }
                        });
                    } catch (parseError) {
                        console.warn(`[TrustyGame] Failed to parse data from key: ${key}`, parseError);
                    }
                }
            }

            console.log(`[TrustyGame] Loaded ${allItems.length} total vocabulary items from all sources.`);
            return allItems;
        } catch (error) {
            console.error("[TrustyGame] Error fetching game data:", error);
            return [];
        }
    },

    /**
     * Generates a random pair (true or false).
     */
    generatePair: (items, qLang = 'en-US', aLang = 'uk-UA') => {
        if (!items || items.length === 0) return null;

        const isCorrect = Math.random() > 0.5;
        const randomIndex = Math.floor(Math.random() * items.length);
        const questionItem = items[randomIndex];

        const questionText = questionItem[qLang] || "";
        let answerText = "";

        if (isCorrect) {
            answerText = questionItem[aLang] || "";
        } else {
            const otherItems = items.filter((_, idx) => idx !== randomIndex);
            const falseItem = otherItems.length > 0
                ? otherItems[Math.floor(Math.random() * otherItems.length)]
                : questionItem;

            answerText = falseItem[aLang] || "";
        }

        return {
            question: questionText,
            answer: answerText,
            isCorrect: answerText === questionItem[aLang],
            originalId: questionItem.id
        };
    },

    /**
     * Calculates game updates based on user guess.
     * With new Bonus/Penalty logic for Score and Time.
     */
    calculateUpdate: (context, userGuess, config) => {
        const {isCorrect} = context.currentPair;
        const isSuccess = userGuess === isCorrect;

        let {score, streak, timer} = context;
        let scoreFlash = isSuccess ? 'success' : 'error'; // Бали спалахують завжди
        let timerFlash = null;

        if (isSuccess) {
            score += config.pointsPerCorrect || 1;
            streak += 1;

            // Логіка бонусних балів
            const scoreBonus = getBonusValue(streak, config.streakBonusMap, config.continuousScoreBonus);
            if (scoreBonus > 0) {
                score += scoreBonus;
            }

            // Логіка бонусного часу
            const timeBonus = getBonusValue(streak, config.timeStreakBonusMap, config.continuousTimeBonus);
            if (timeBonus > 0) {
                timer += timeBonus;
                timerFlash = 'success'; // Спалах таймера ТІЛЬКИ при бонусі
            }
        } else {
            score = Math.max(0, score - (config.penaltyPoints || 1));
            streak = 0;
            timer = Math.max(0, timer - (config.timePenalty || 1));
            timerFlash = 'error'; // Спалах таймера ТІЛЬКИ при штрафі
        }

        return {
            score,
            streak,
            timer,
            feedback: {score: scoreFlash, timer: timerFlash}
        };
    },


};

/**
 * Helper to get bonus value based on current streak and mode
 */
const getBonusValue = (currentStreak, bonusMap, isContinuous) => {
    if (!bonusMap) return 0;

    // Знаходимо всі пороги, які менші або дорівнюють поточному стріку
    const thresholds = Object.keys(bonusMap)
        .map(Number)
        .filter(t => t <= currentStreak)
        .sort((a, b) => b - a); // сортуємо за спаданням, щоб отримати найвищий досягнутий поріг

    if (thresholds.length === 0) return 0;

    const topThreshold = thresholds[0];

    if (isContinuous) {
        // У постійному режимі повертаємо бонус за кожну ітерацію після досягнення порогу
        return bonusMap[topThreshold];
    } else {
        // У звичайному режимі — ТІЛЬКИ якщо стрік дорівнює порогу (одноразово)
        return currentStreak === topThreshold ? bonusMap[topThreshold] : 0;
    }
}
